module.exports = __webpack_public_path__ + "img/第3档.299f5fdb.png";